import React from "react";

import { Route, Switch, BrowserRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { lazyImport } from "./util/lazyImport";

// stores
import { useManagerStore } from "./zustand/manager";
import storage from "./util/storage";

//components
import Layout from "./shared/Layout";
import api from "./api";

//pages
const PTSRouter = lazyImport(() => import("./PTS/Router"));
const DTARouter = lazyImport(() => import("./DTA/Router"));
const PFFRouter = lazyImport(() => import("./PFF/Router"));
const LSSRouter = lazyImport(() => import("./LSS/Router"));
const Home = lazyImport(() => import("./pages/Home"));
const Login = lazyImport(() => import("./pages/Login"));
const MyPage = lazyImport(() => import("./pages/MyPage"));
const BoardList = lazyImport(() => import("./pages/BoardList"));
const BoardDetail = lazyImport(() => import("./pages/BoardDetail"));
const BoardWrite = lazyImport(() => import("./pages/BoardWrite"));
const FilePage = lazyImport(() => import("./pages/FilePage"));

const PublicRouter = () => {
    return (
        <Switch>
            <Route path="/login" exact component={Login} />
        </Switch>
    );
};

const PrivateRouter = () => {
    const history = useHistory();

    const pathname = window.location.pathname;
    if (pathname.includes("/dataTagAdmin")) return <DTARouter />;
    if (pathname.includes("/priceTagSystem")) return <PTSRouter />;
    if (pathname.includes("/portfolioFinder")) return <PFFRouter />;
    if (pathname.includes("/lifestyleSync")) return <LSSRouter />;
    if (pathname === "/login") history.push("/");

    return (
        <Switch>
            <Route path="/mypage" exact component={MyPage} />
            <Route path="/file" exact component={FilePage} />
            <Route path="/board" exact component={BoardList} />
            <Route path="/board/detail/:id" exact component={BoardDetail} />
            <Route path="/board/write/:id" exact component={BoardWrite} />
            <Route path="/" component={Home} />
        </Switch>
    );
};
export default function Router() {
    const history = useHistory();
    const [is_login, setLogin] = React.useState(undefined);
    const { manager, loginCheck } = useManagerStore();

    const __token = storage.getToken();

    React.useEffect(() => {
        if (!__token && !manager.token) {
            if (window.location.pathname === "/login") {
                return;
            }

            window.location.href = "/login";
        }

        if (__token && __token !== manager.token) {
            api.auth
                .loginCheck()
                .then((res) => {
                    loginCheck({ ...res, token: __token });
                })
                .catch((err) => {
                    setLogin(false);
                });
        }

        if (__token && __token === manager.token) {
            setLogin(true);
        }
    }, [manager, history]);

    return (
        <BrowserRouter>
            {is_login ? (
                <Layout>
                    <PrivateRouter />
                </Layout>
            ) : (
                <PublicRouter />
            )}
        </BrowserRouter>
    );
}
